import React from 'react';
import './ServicesHeader.css';

/**
 * F6 — Services article header.
 *
 * Title + "M/N active" mono pill + legend chips (Booked / Open / Lunch).
 */
const ServicesHeader = ({ activeCount = 0, totalCount = 0 }) => (
  <header className="appointments-v3-services-head">
    <div className="appointments-v3-services-head-title-line">
      <h3 className="appointments-v3-services-head-title">Services</h3>
      <span className="appointments-v3-services-head-count">
        {activeCount}/{totalCount} active
      </span>
    </div>
    <p className="appointments-v3-services-head-subtitle">
      Each service generates its own slots daily based on duration and schedule.
    </p>
    <div className="appointments-v3-services-head-legend" aria-label="Capacity legend">
      <span className="appointments-v3-services-head-legend-item">
        <span className="appointments-v3-services-head-swatch is-booked" aria-hidden="true" />
        Booked
      </span>
      <span className="appointments-v3-services-head-legend-item">
        <span className="appointments-v3-services-head-swatch is-open" aria-hidden="true" />
        Open
      </span>
      <span className="appointments-v3-services-head-legend-item">
        <span className="appointments-v3-services-head-swatch is-lunch" aria-hidden="true" />
        Lunch
      </span>
    </div>
  </header>
);

export default ServicesHeader;
